<router-outlet id="sotLayerOutlet" #sotLayerOutlet="outlet"></router-outlet>
<sot-preloaded-images></sot-preloaded-images>